const topbar = {
    docs: '文件',
    help: '幫助',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
